import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import ButtonGroup from "../ButtonGroup";
import dictionary from "../../../dictionary";
import {shortCurrency} from "../../../utils/currency";

import styles from "./button-group.module.scss";

function ChocolateType(props) {
  const {name, content, onChange, current, currency} = props;

  return (
    <div className={styles.root}>
      <ButtonGroup
        current={current}
        buttons={content}
        onChange={(value) => onChange(name, value)}
        renderButton={({value, difference}) => (
          <span className={styles.value}>
            {dictionary.item[value]}
            {` `}
            {value !== current && difference && (
              <span className={styles.difference}>{difference}{shortCurrency(currency, difference)}</span>
            )}
          </span>
        )}
      />
      <span className={styles.label}>– шоколад в наличии</span>
    </div>
  );
}

ChocolateType.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      difference: PropTypes.string
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func
};

const mapStateToProps = (state) => ({
  currency: state.currency
})

export default connect(mapStateToProps)(ChocolateType);
